<nz-spin [nzSpinning]="loading$ | async">
  <form
    class="form"
    [formGroup]="createOwnStrategyForm"
    (ngSubmit)="createOwnStrategy()">
    <div class="drawer-form-wrapper">
      <app-student-info-card
        [student]="caseParams.case?.student"
        [supervisorName]="caseParams.case?.supervisorName">
      </app-student-info-card>
      <app-behavior-info-card
        [mode]="mode"
        [behaviorCategoryName]="caseParams.behavior?.behaviorCategoryName"
        [behaviorTypes]="caseParams.behavior?.behaviorCategoryTypes">
      </app-behavior-info-card>

      <div class="form-grid">
        <nz-form-item>
          <nz-form-label nzFor="title" nzRequired>Title</nz-form-label>
          <nz-form-control [nzErrorTip]="titleErrorTpl">
            <input
              id="title"
              type="text"
              nz-input
              formControlName="title"
              placeholder="Enter title" />
            <ng-template #titleErrorTpl let-control>
              <div *ngIf="isFieldInvalid('title')" class="error-message">
                {{ getErrorMessage('title') }}
              </div>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
      </div>

      <nz-form-item>
        <nz-form-label nzFor="description" nzRequired
          >Description</nz-form-label
        >
        <nz-form-control [nzErrorTip]="descriptionErrorTpl">
          <textarea
            id="description"
            formControlName="description"
            rows="4"
            nz-input
            placeholder="Add description"></textarea>
          <ng-template #descriptionErrorTpl let-control>
            <div *ngIf="isFieldInvalid('description')" class="error-message">
              {{ getErrorMessage('description') }}
            </div>
          </ng-template>
          <span class="hint-text">
            {{ getRemainingChars('description') }} of
            {{ MAX_LENGTHS.description }} characters used
          </span>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="guidelines" formArrayName="guidelines">
        <nz-form-label nzRequired>Guidelines</nz-form-label>
        <nz-form-control [nzErrorTip]="guidelinesErrorTpl">
          <div
            *ngFor="let guideline of guidelinesArray.controls; let i = index"
            [formGroupName]="i">
            <nz-form-item>
              <nz-form-control>
                <textarea
                  rows="3"
                  nz-input
                  formControlName="guideline"
                  placeholder="Enter guideline"></textarea>
                <div class="input-actions">
                  <div class="display-flex guideline-actions">
                    <button
                      nz-button
                      type="button"
                      nzType="default"
                      (click)="addGuideline()"
                      *ngIf="showAddButton(i)">
                      <svg-icon
                        src="/assets/icon/icon-plus.svg"
                        class="icon s-16"></svg-icon>
                      <span class="s-14">Add Guideline</span>
                    </button>
                    <button
                      nz-button
                      type="button"
                      nzType="default"
                      (click)="removeGuideline(i)"
                      *ngIf="showDeleteButton(i)">
                      <svg-icon
                        src="/assets/icon/icon-trash.svg"
                        class="icon s-16"></svg-icon>
                      <span class="s-14">Delete Guideline</span>
                    </button>
                  </div>
                </div>
              </nz-form-control>
            </nz-form-item>
          </div>
        </nz-form-control>
        <ng-template #guidelinesErrorTpl let-control>
          <div
            *ngIf="
              createOwnStrategyForm.get('guidelines')?.errors?.['required'] &&
              createOwnStrategyForm.get('guidelines')?.touched
            "
            class="error-message">
            Guidelines are required
          </div>
        </ng-template>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="details" nzRequired>Details</nz-form-label>
        <nz-form-control [nzErrorTip]="detailsErrorTpl">
          <textarea
            id="details"
            formControlName="details"
            rows="4"
            nz-input
            placeholder="Add details"></textarea>
          <ng-template #detailsErrorTpl let-control>
            <div *ngIf="isFieldInvalid('details')" class="error-message">
              {{ getErrorMessage('details') }}
            </div>
          </ng-template>
          <span class="hint-text">
            {{ getRemainingChars('details') }} of
            {{ MAX_LENGTHS.details }} characters used
          </span>
        </nz-form-control>
      </nz-form-item>

      <div class="drawer-footer">
        <button
          nz-button
          type="button"
          nzType="default"
          (click)="closeDrawers()">
          Cancel
        </button>
        <div>
          <button
            class="create-own-strategy"
            type="button"
            nz-button
            nzType="primary"
            [disabled]="createOwnStrategyForm.invalid"
            (click)="
              mode === 'edit' ? createModification() : saveStrategy(false)
            ">
            {{ mode === 'edit' ? 'Save Modification' : 'Save' }}
          </button>

          <button
            *ngIf="mode !== 'edit'"
            type="button"
            nz-button
            nzType="primary"
            [disabled]="createOwnStrategyForm.invalid"
            (click)="saveStrategy(true)">
            Save to District Records
          </button>
        </div>
      </div>
    </div>
  </form>
</nz-spin>
